// UI-only mode: unavailable in production and outside localhost.
export const previewMode = process.env.NODE_ENV === 'development'
  && process.env.VUE_APP_UI_PREVIEW === 'true'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);
